/* ============================================================
   NIGHTLEGS — STICKY ATC BAR
   Appears after scrolling past the main ATC button.
   Hides when cart drawer is open.
   ============================================================ */

(function() {
  'use strict';

  var stickyBar  = document.getElementById('sticky-atc');
  var atcBtnMain = document.getElementById('product-atc-row');

  if (!stickyBar || !atcBtnMain) return;

  var isCartOpen = false;

  document.addEventListener('cart:open',  function() { isCartOpen = true;  updateVisibility(); });
  document.addEventListener('cart:close', function() { isCartOpen = false; updateVisibility(); });

  function updateVisibility() {
    if (isCartOpen) {
      stickyBar.classList.remove('is-visible');
      stickyBar.setAttribute('aria-hidden', 'true');
      return;
    }

    var rect       = atcBtnMain.getBoundingClientRect();
    var pastButton = rect.bottom < 0;

    if (pastButton) {
      stickyBar.classList.add('is-visible');
      stickyBar.setAttribute('aria-hidden', 'false');
    } else {
      stickyBar.classList.remove('is-visible');
      stickyBar.setAttribute('aria-hidden', 'true');
    }
  }

  window.addEventListener('scroll', updateVisibility, { passive: true });
  updateVisibility();
})();
